import { render, staticRenderFns } from "./Seas.vue?vue&type=template&id=98d97120"
import script from "./Seas.vue?vue&type=script&lang=js"
export * from "./Seas.vue?vue&type=script&lang=js"
import style0 from "./Seas.vue?vue&type=style&index=0&id=98d97120&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports